import { render, staticRenderFns } from "./AppointmentProceduresCard.vue?vue&type=template&id=735c7543&scoped=true&"
import script from "./AppointmentProceduresCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentProceduresCard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentProceduresCard.vue?vue&type=style&index=0&id=735c7543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c7543",
  null
  
)

export default component.exports